module.exports = __webpack_public_path__ + "img/Family_Inside_Condo.ae7cfab.png";